export default __webpack_public_path__ + "static/media/Ballroll_00052.493a9f6c.png";